module.exports = __webpack_public_path__ + "static/media/Calibre-Regular.b63c62e5.woff2";